import {Controller} from '@hotwired/stimulus';

import Carousel from "bootstrap/js/dist/carousel";
import Collapse from "bootstrap/js/dist/collapse";
// import '../styles/components/criminal-sections.scss'

export default class extends Controller {
    connect() {
        super.connect();

        this.init();
        // window.removeEventListener('resize', this.resize());
        // window.addEventListener('resize', this.resize());
        // window.onresize = this.init();


        this.element.querySelectorAll('.ci').forEach(function (item) {
            item.addEventListener('shown.bs.collapse', function () {

                // var itemHeight = this.scrollHeight;
                let headerHeight = document.getElementById('header').offsetHeight;
                let itemDistanceFromScreenTop = this.getBoundingClientRect().top;
                let windowScrollY = window.scrollY;

                // if (itemDistanceFromScreenTop < headerHeight + 16) {
                //   window.scrollTo({
                //     top: windowScrollY + itemDistanceFromScreenTop - headerHeight - 16,
                //     behavior: 'smooth'
                //   });
                // }

                // window.scrollTo({
                //     top: windowScrollY + Math.abs(itemDistanceFromScreenTop) - headerHeight - 16,
                //     behavior: 'smooth'
                // });

                // console.log(windowScrollY + itemDistanceFromScreenTop - headerHeight - 16);

                // console.log('itemHeight: ' + itemHeight);
                // console.log('innerheight of window: ' + window.innerHeight);
                // console.log('this.offsetTop: ' + this.offsetTop);
                // console.log('this.getBoundingClientRect().top: ' + this.getBoundingClientRect().top);
                // console.log('window.scrollY: ' + window.scrollY);


                // window.scrollTo({
                //   top: 0,
                //   behavior: 'smooth'
                // });

            });
        });
    }

    reset() {
        // const criminalCarouselElement = document.querySelector('#criminalCarousel')

        let element = document.querySelector('[data-controller="criminal-section"]');

        // element.replaceWith(element.cloneNode(true))
        // console.log(element)
        // element.setAttribute('data-controller', '');
        // setTimeout(() => {
        // element.setAttribute('data-controller', 'criminal-section');
        // }, 1000)

        // this.recreateNode(this.element)
    }

    recreateNode(el, withChildren) {
        if (withChildren) {
            el.parentNode.replaceChild(el.cloneNode(true), el);
        } else {
            let newEl = el.cloneNode(false);
            while (el.hasChildNodes()) newEl.appendChild(el.firstChild);
            el.parentNode.replaceChild(newEl, el);
        }
    }

    init() {
        const collapseElementList = this.element.querySelectorAll('.ci');
        const criminalCarouselElement = this.element.querySelector('#criminalCarousel');

        if (criminalCarouselElement) {
            const carousel = new Carousel(criminalCarouselElement);

            this.element.querySelectorAll('.criminalSvg').forEach((svgItem, index) => {
                svgItem.addEventListener('click', (event) => {
                    carousel.to(index);
                })
            })

            criminalCarouselElement.addEventListener('slide.bs.carousel', (event) => {
                this.element.querySelectorAll('.criminalSvg').forEach((svgItem) => {
                    svgItem.classList.remove('active')
                })
                this.element.querySelectorAll('.criminalSvg')[event.to].classList.add('active');
                const color = this.element.querySelectorAll('.criminalSvg')[event.to].querySelector('path').style.stroke;
                event.relatedTarget.style.setProperty('--item-bg', color)
            })
        }

        if (collapseElementList.length === 0) return;

        const collapseList = [...collapseElementList].map(collapseEl => new Collapse(collapseEl, {
            toggle: false,
            parent: this.element.querySelector('.carousel-inner')
        }));
        const accHeaders = this.element.querySelectorAll('.accHeader');

        collapseList.forEach((item, index) => {
            item._element.addEventListener('show.bs.collapse', () => {
                if (index + 1 < accHeaders.length) {
                    accHeaders[index + 1].querySelector('path:nth-child(3)').style.display = "none";
                    accHeaders[index + 1].querySelector('polygon').style.display = "none";
                }
            })
            item._element.addEventListener('hide.bs.collapse', () => {
                this.element.querySelectorAll('.accHeader path:nth-child(3)').forEach((it) => {
                    it.style.display = "block";
                });
                this.element.querySelectorAll('.accHeader polygon').forEach((it) => {
                    it.style.display = "block";
                });
            })
        })

        accHeaders.forEach((item, index) => {
            if (!collapseList[index]) return;
            const color = item.querySelector('path').style.stroke;
            collapseList[index]._element.style.setProperty('--item-bg', color);
        })
    }
}
